<div class="card">
  <h5 class="card-header">
    <span class="fa fa-table"></span> &nbsp; Agreements
  </h5>
  <div class="card-body p-0">
    <div #vw_UserAgreementSubGrid style="width: 100%;" class="ag-fresh"></div>
  </div>
</div>